import {Component, Input, OnInit} from '@angular/core';
import {ConsentsFormService} from '../../../../../services/consents-form.service';

@Component({
  selector: 'app-student-form-cards',
  templateUrl: './student-form-cards.component.html',
  styleUrls: ['./student-form-cards.component.scss']
})
export class StudentFormCardsComponent implements OnInit {
  @Input() notifications: any;
  @Input() child: any;
  @Input() user: any;
  constructor(private consentsFormService: ConsentsFormService) { }

  ngOnInit(): void {
  }

  async showConsent(child, notification: any) {
    await this.consentsFormService.showCustomForm(notification, this.user, child);
  }
}
